<template>
    <div id="app">
    <router-view></router-view>
    </div>
</template>

<script>

    import Vue from 'vue';
    import Element from 'element-ui';
    import locale from 'element-ui/lib/locale/lang/en';

    Vue.use(Element, {locale});

    export default {
        components: {

        },
        data() {
            return {
            }
        },
        mounted() {
        },
        created() {
        },
        methods: {
        }
    }
</script>